import { useSelector, useDispatch } from 'react-redux'
import { Alert, Progress } from 'reactstrap'
import { setSelectedRateForGroupAction } from '../../../redux/storeConfig/slices/slice.checkoutRates'
import ShippingGroup from './ShippingGroup'
import { isFreeShippingRate } from './shippingGroupsHelpers'

const ShippingMethodSelector = () => {
  const dispatch = useDispatch()
  const checkoutRates = useSelector(state => state.checkoutRates)
  const cartItems = useSelector(state => state.cartItems)

  const shippingGroups = checkoutRates?.rates || []
  const selectedRatesByGroup = checkoutRates?.selectedRatesByGroup || {}
  const isCalculating = checkoutRates?.isCalculating || false
  const calculationProgress = checkoutRates?.calculationProgress

  const handleRateSelect = (groupId, rate, cartItemIds, customerAddressId) => {
    dispatch(
      setSelectedRateForGroupAction(groupId, {
        service_code: rate.service_code,
        cost_in_cents: rate.cost_in_cents,
        encrypted_cost: rate.encrypted_cost,
        carrier_service_id: rate.carrier_service_id,
        cart_item_ids: cartItemIds,
        customer_address_id: customerAddressId
      })
    )
  }

  if (!shippingGroups.length) {
    return null
  }

  const hasPaidRates = shippingGroups.some(g => g.rates?.length > 0)
  const hasFreeShipping = shippingGroups.some(
    g => !g.rates?.length && isFreeShippingRate(selectedRatesByGroup[g.carrier_service_group_id])
  )
  const hasShippingResolved = hasPaidRates || hasFreeShipping

  return (
    <div className="shipping-method-selector box-shadow white-background m-0 mb-3">
      <div className="ckout-header">
        <h5 className="m-0">Shipping Method</h5>
      </div>

      <div className="p-3">
        {isCalculating && calculationProgress && (
          <div className="mb-3">
            <Progress animated value={calculationProgress.progressPercent}>
              {calculationProgress.progressPercent.toFixed(0)}%
            </Progress>
          </div>
        )}

        {hasShippingResolved && cartItems.some(item => item.fulfillment_production_time) && (
          <Alert color="warning" className="mb-3">
            <strong>Production Time:</strong> Some products may require additional production time before fulfillment.
            Please review individual product details below.
          </Alert>
        )}

        {shippingGroups.map((group, index) => (
          <ShippingGroup
            key={group.carrier_service_group_id}
            group={group}
            groupIndex={index}
            totalGroups={shippingGroups.length}
            selectedRate={selectedRatesByGroup[group.carrier_service_group_id]}
            onRateSelect={rate => handleRateSelect(group.carrier_service_group_id, rate, group.line_items.map(li => li.cart_item_id), group.destination_address?.id)}
            cartItems={cartItems}
          />
        ))}
      </div>
    </div>
  )
}

export default ShippingMethodSelector
